<template>
    <div style="margin: 0px 0px; width: 100%;" class="pdf-section-wrapper pdf-avoid-page-break" id="symptoms-summary">
  
        <div>
            <div v-for="(group, index) in displayedGroups" :key="index" style="" >
                <SectionWrapper :title="isTenPoint ? 'Symptoms (10 Point)' : 'Symptoms'" title-only >
                    <div style="display: flex; align-items: center">
                        <div style="margin-right: 30px; font-weight: bolder" v-if="index === 0 && isTenPoint">
                            How Do You Feel <span class="symptoms-value">{{howDoYouFeelScore}}</span>
                        </div>
                        <div style="margin-right: 30px; font-weight: bolder" v-if="index === 0">
                            SYMPTOM TOTAL <span class="symptoms-value">{{group.value}}</span>
                        </div>
                        <div v-for="(item, itemIndex) in group.items" :key="itemIndex" style="margin-right: 20px">
                            {{item.text}} <span class="symptoms-value">{{item.value}}</span>
                        </div>
                    </div>
                </SectionWrapper>
            </div>
        </div>
        
            


    </div>
</template>

<script>
import ProfileTest from "@/js/shared/classes/ProfileTest/SwayProfileTest";
import SectionWrapper from "@/components/pdf-export/SectionWrapper";
import gsap from "gsap";

export default {
    name: "SymptomsSummarySection",
    components: {
        SectionWrapper,
    },
    props: {
        profileTest: {
            type: ProfileTest,
            required: true
        }
    },
    data() {
        return {
            // results: null,
            groupedSymptoms: null,
            open: false,
            isTenPoint: false,
            howDoYouFeelScore: null,
        }
    },
    watch: {
        open() {
            if (!this.open) {
                gsap.to(this.$refs.expandChevron, {
                    rotationZ: 0,
                    duration: .2
                })
            } else {
                gsap.to(this.$refs.expandChevron, {
                    rotationZ: 180,
                    duration: .2
                })
            }
        }
    },
    mounted() {
        // this.results = this.profileTest.getMeasureResultsByName('symptoms').results;
        let response = this.profileTest.getGroupedSymptoms();
        
        this.isTenPoint = response.isTenPoint;
        this.howDoYouFeelScore = response.howDoYouFeelScore;
        this.groupedSymptoms = response.groupedSymptoms;
    },
    computed: {
        totalScore() {
            
            if (!this.groupedSymptoms) return null
            
            let totalScore = 0
            
            for (let item in this.groupedSymptoms) {
                totalScore += this.groupedSymptoms[item].totalScore
            }
            
            return totalScore
        },
        displayedGroups() {
            if (!this.groupedSymptoms) return []
            
            let response = [];
            
            response.push({
                label: 'Overview',
                value: this.totalScore,
                items: [
                    {
                        text: 'Physical',
                        value: this.groupedSymptoms.physical.totalScore
                    },
                    {
                        text: 'Cognitive',
                        value: this.groupedSymptoms.cognitive.totalScore
                    },
                    {
                        text: 'Emotional',
                        value: this.groupedSymptoms.emotional.totalScore
                    },
                    {
                        text: 'Sleep-Arousal',
                        value: this.groupedSymptoms.sleepArousal.totalScore
                    },
                    
                ]
            });
            
            return response
        },
        symptoms() {
            return this.profileTest.data.symptoms
        }
    }

}
</script>

<style scoped>




</style>